module.exports = __webpack_public_path__ + "static/media/BrownsLogo.cc7b209f.png";